module.exports = __webpack_public_path__ + "static/media/Play to earn.efe97ca3.png";